import type { GetProps } from "antd";
import { Typography } from "antd";
import type { FC } from "react";

export type IotTypographyTextProps = GetProps<typeof Typography.Text>;

export const IotTypographyText: FC<IotTypographyTextProps> = (props) => (
    <Typography.Text {...props} />
);
